import React from 'react';
import { IOrder } from '../../../types';

export function CheckoutLabel({ type }: { type: IOrder['checkoutType'] }) {
  if (!type) return null;
  return (
    <span className="inline-flex w-fit whitespace-nowrap rounded-full bg-neutral-200 px-2 text-[11px] leading-[18px] text-text">
      {type === 'GROUP_ORDER' ? 'Group order' : 'Multiple brands'}
    </span>
  );
}
